import { ARTICLE_LINK_CLICKED, ARTICLE_SHARED, ARTICLE_VIDEO_STARTED } from 'config/types/action';
import getPageTrackingData from 'selectors/getPageTrackingData';
import { trackPageEvent } from 'utils/tracking';

const eventToTrackableMap = {
  [ARTICLE_LINK_CLICKED]: ({ text, url }) => ({
    link_text: text,
    link_url: url,
    name: 'magazine_page:link_clicked',
    version: 1,
  }),
  [ARTICLE_VIDEO_STARTED]: ({ url }) => ({
    name: 'magazine_page:video_started',
    version: 2,
    video_url: url,
  }),
  [ARTICLE_SHARED]: ({ sharing_platform }) => ({
    name: 'magazine_page:shared',
    sharing_platform,
    version: 3,
  }),
};

const trackableEvents = Object.keys(eventToTrackableMap);

const trackAction = ({ payload, type }, trackingData) => trackPageEvent({
  ...trackingData,
  ...eventToTrackableMap[type](payload),
});

/*

This middleware is in charge of sending tracking events from redux actions.
It will be triggered on every dispatched action.
As long as all the tracking data has not been retrieved, it adds the actions to a queue to be tracked later.
Once the page tracking data is available, it sends all the events that were added to the queue.
It starts tracking events instantly from that point on.

*/
const trackingMiddleware = (store) => {
  let actionsQueue = [];
  return (next) => (action) => {
    const result = next(action);
    const trackingData = getPageTrackingData(store.getState());
    if (0 < actionsQueue.length && !trackingData.isLoading) {
      actionsQueue.forEach((queuedAction) => trackAction(queuedAction, trackingData.data));
      actionsQueue = [];
    }
    if (trackableEvents.includes(action.type)) {
      if (trackingData.isLoading) {
        actionsQueue.push(action);
      } else {
        trackAction(action, trackingData.data);
      }
    }
    return result;
  };
};

export default trackingMiddleware;
